document.addEventListener('DOMContentLoaded', function () {
  const menuDropdown = document.getElementById('menu-dropdown');
  const menuButton = document.getElementById('mobile-menu-button');
  const openButton = document.getElementById('open-button');
  const closeButton = document.getElementById('close-button');
  const menuHeader = document.getElementById('header-group') || document.querySelector('.mada-header') || document.querySelector('header');
  const mainContent = document.getElementById('MainContent');
  const footerContent = document.querySelector('footer');

  if (!menuButton || !menuDropdown) return;

  const getHeaderHeight = () => (menuHeader ? menuHeader.offsetHeight : 0);
  let isOpen = false;

  function openMenu() {
    menuDropdown.style.top = `${getHeaderHeight()}px`;
    menuDropdown.classList.add('is-open');
    menuButton.setAttribute('aria-expanded', 'true');
    openButton.style.display = "none";
    closeButton.style.display = "block";
    mainContent.classList.add("blur-filter");
    footerContent.classList.add("blur-filter");
    isOpen = true;
  }

  function closeMenu() {
    menuDropdown.classList.remove('is-open');
    menuButton.setAttribute('aria-expanded', 'false');
    // move offscreen as fallback for hiding
    menuDropdown.style.top = '-100vh';
    openButton.style.display = "block";
    closeButton.style.display = "none";
    mainContent.classList.remove("blur-filter");
    footerContent.classList.remove("blur-filter");
    isOpen = false;
  }

  function toggleMenu(event) {
    if (event) event.preventDefault();
    isOpen ? closeMenu() : openMenu();
  }

  function onBodyClick(event) {
    if (!isOpen) return;
    if (!menuDropdown.contains(event.target) && !menuButton.contains(event.target)) {
      closeMenu();
    }
  }

  menuButton.addEventListener('click', toggleMenu);
  document.body.addEventListener('click', onBodyClick);
  window.addEventListener('resize', function () {
    if (isOpen) menuDropdown.style.top = `${getHeaderHeight()}px`;
  });

  // ensure initial accessible state
  menuButton.setAttribute('aria-expanded', 'false');
});